import type { SilentRequest } from "@azure/msal-browser";
import type { IMsalContext } from "@azure/msal-react";

import { ADB2C_INSTANCE, ADB2C_SCOPES, ADB2C_TENANT } from "../config.ts";

export function makeTokenRequestObject(
  msalInstance: IMsalContext["instance"],
): SilentRequest {
  const account = msalInstance.getActiveAccount();

  const obj: SilentRequest = {
    account: account ?? undefined,
    scopes: ADB2C_SCOPES,
  };

  if (account && "tenantId" in account && account.tenantId !== "") {
    obj.authority = `https://${ADB2C_INSTANCE}/${ADB2C_TENANT}/${account.tenantId}`;
  }

  return obj;
}
